module.exports = __webpack_public_path__ + "img/indie_group_3.334ef7da.png";